/**
 * Werte, die Frontend und Backend teilen. Eine Quelle, keine doppelte Pflege.
 */
/*
 * Drei Rollen, mehr braucht die Anwendung nicht.
 *
 * Bis zum Wegfall des Eigentuemerportals gab es eine vierte, "customer". Sie
 * war der Zugang des Eigentuemers. Ohne Portal fuehrt sie nirgendwo mehr hin,
 * und eine Anmelderolle ohne Ziel ist genau die Altlast, ueber die spaeter
 * jemand stolpert. Der Kunde bleibt als Datensatz bestehen, er hat nur keinen
 * eigenen Zugang mehr.
 */
export const ROLES = ["admin", "lead", "employee"];
/** Sprachen der Mitarbeiteroberflaeche. Arabisch laeuft von rechts nach links. */
export const LOCALES = ["de", "en", "es", "ar"];
/** Sprachen, in denen ein Kundenbericht erscheinen kann. */
export const CUSTOMER_LOCALES = ["de", "en"];
export const RTL_LOCALES = ["ar"];
export function isRtl(locale) {
    return RTL_LOCALES.includes(locale);
}
/** Rollen, die im Backoffice arbeiten. Zurzeit alle. */
export const STAFF_ROLES = ["admin", "lead", "employee"];
export function isStaff(role) {
    return STAFF_ROLES.includes(role);
}
/**
 * Erlaubte Form eines Bereichsschluessels.
 *
 * Kleinbuchstaben, Ziffern, Unterstrich. Der Schluessel steht in
 * Fremdschluesseln, am Anfang jedes Pruefpunktschluessels und in Vergleichen;
 * getippt wird er nie, den bildet der Server aus dem Namen. Dieselbe Regel
 * steht als Bedingung an der Tabelle, siehe Migration 0053.
 */
export const BEREICH_SCHLUESSEL = /^[a-z0-9][a-z0-9_]{0,39}$/;
export const TOKEN_TTL = {
    /** Kurz, damit ein abgefangenes Token schnell wertlos ist. */
    accessSeconds: 15 * 60,
    /** Lang, damit ein Mitarbeiter nicht taeglich sein Passwort tippt. Widerrufbar. */
    refreshSeconds: 30 * 24 * 60 * 60,
    /** Einladung fuer Kunden und neue Mitarbeiter. */
    invitationSeconds: 7 * 24 * 60 * 60
};
/** Markenfarben aus dem Markenkit. Werden als CSS-Variablen ausgespielt. */
export const BRAND = {
    amber: "#E2A63C",
    amberDark: "#F0A315",
    amberLight: "#D5B680",
    black: "#070707",
    white: "#FFFFFF",
    sand: "#F0EDE4",
    warmGrey: "#8B8680"
};
